import { useFetch } from "use-http";
import { interpolate } from "react-arc";
import config from "../../../../config/config";

function useBoardPublish({ token, data }) {
  const url = interpolate(config.boards.publish, data);
  const { post, response, loading, error } = useFetch(url, {
    cacheLife: 0,
    cachePolicy: "no-cache",
    headers: {
      "Content-Type": "application/json",
      "X-Auth-Token": token,
    },
  });

  const handleRequest = () => {
    return post({
      board_id: data.id,
    });
  };

  return [error, loading, response, handleRequest];
}

export default useBoardPublish;
